import { useState, useCallback } from 'react';

export type UseHoverReturn = {
    isHovered: boolean;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
};

export const useHover = (): UseHoverReturn => {
    const [isHovered, setIsHovered] = useState(false);

    const onMouseEnter = useCallback(() => {
        setIsHovered(true);
    }, []);

    const onMouseLeave = useCallback(() => {
        setIsHovered(false);
    }, []);

    return {
        isHovered,
        onMouseEnter,
        onMouseLeave,
    };
};
